var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57253 4.03538C8.56402 4.02452 8.55316 4.01573 8.54076 4.00969C8.52835 4.00364 8.51473 4.0005 8.50094 4.0005C8.48714 4.0005 8.47352 4.00364 8.46112 4.00969C8.44872 4.01573 8.43785 4.02452 8.42935 4.03538L7.15663 5.6456C7.11004 5.70469 7.15209 5.79219 7.22822 5.79219H8.07026V9.63761C8.07026 9.68761 8.11117 9.72852 8.16117 9.72852H8.84298C8.89298 9.72852 8.93389 9.68761 8.93389 9.63761V5.79332H9.77365C9.84979 5.79332 9.89183 5.70582 9.84524 5.64673L8.57253 4.03538Z",
    fill: "#323234"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.978 9.2959H12.6598C12.7098 9.2959 12.7507 9.33681 12.7507 9.38681V11.6368C12.7507 11.8379 12.5882 12.0004 12.3871 12.0004H4.61949C4.41836 12.0004 4.25586 11.8379 4.25586 11.6368V9.38681C4.25586 9.33681 4.29677 9.2959 4.34677 9.2959H5.02858C5.07858 9.2959 5.11949 9.33681 5.11949 9.38681L5.11439 11.1368H11.8871V9.38681C11.8871 9.33681 11.928 9.2959 11.978 9.2959Z",
    fill: "#323234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2a5e10aa0e10f020fb03ef04714661ca.svg";
export { ForwardRef as ReactComponent };